module.exports = __webpack_public_path__ + "img/expand_btn.9fc9ec9a.svg";